export const formatVideoUrlForIframe = (url: URL, autoplay: boolean | undefined) => {
  let videoId = url.searchParams.get('v');  
  if (!videoId && url.hostname === 'youtu.be') {
    videoId = url.pathname.substring(1);
  }
  if (!videoId && url.hostname.includes('youtube.com') && url.pathname.startsWith('/shorts/')) {
    const parts = url.pathname.split('/shorts/');
    if (parts.length > 1 && parts[1]) {
      videoId = parts[1].split('/')[0] || null;
    }
  }
  if (!videoId) return '';
  const params = new URLSearchParams(url.search);
  params.delete('v');
  params.set('enablejsapi', '1');
  if (autoplay) {
    params.set('autoplay', '1');
    params.set('mute', '1');
  }

  const urlOrigin = url.host === 'youtu.be'
    ? 'https://www.youtube.com'
    : url.origin

  return `${urlOrigin}/embed/${videoId}?${params.toString()}`;
}

export const getYoutubeThumbnail = (videoUrl: string): string | null => {
  const standardMatch = videoUrl.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/);
  if (standardMatch) {
    return `https://i.ytimg.com/vi/${standardMatch[1]}/hqdefault.jpg`;
  }

  const shortsMatch = videoUrl.match(/youtube\.com\/shorts\/([\w-]+)/);
  if (shortsMatch) {
    return `https://i.ytimg.com/vi/${shortsMatch[1]}/hqdefault.jpg`;
  }

  return null;
};

export const getTweetId = (embedHtml: string): string | null => {
  // Match both twitter.com and x.com URLs that contain /status/<id>
  const regex = /https?:\/\/(?:x\.com|twitter\.com)\/[^/]+\/status\/(\d+)/i;
  const match = embedHtml.match(regex);
  return match && match[1] ? match[1] : null;
}